import { createAction, props } from '@ngrx/store';

export const setEpubDictionary = createAction(
  '[Config] Set ePub id:url',
  props<{ epub: Record<string, string> }>(),
);
